import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Modal,
  Row,
  Select,
  Tooltip,
} from "antd";
// import { url_get_list_district } from "../../../../constants";
// import Cookies from "universal-cookie";
// import { authAxios } from "../../../../utils";
import moment from "moment";
import "./style.css";
import {
  // disabledDate,
  validateMessages,
  disabledDatePast,
} from "../../../Function";
import { QuestionCircleOutlined } from "@ant-design/icons";

// const cookies = new Cookies();
const dateFormat = "DD/MM/YYYY";

const index = ({
  isModalAddCVInterview,
  setIsModalAddCVInterview,
  fetchListInterview,
  onFinishAddCVInterview,
  selectedRowKeys,
  dataCaditateManagement,
  dataInterview,
}) => {
  const [form] = Form.useForm();
  // const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [dataCV, setDataCV] = useState([]);

  const handleCancelCVInterview = () => {
    setIsModalAddCVInterview(false);
  };

  const handleChangeDate = (date) => {
    // setSelectedDate(date);
    form.setFieldsValue({
      id_interview: undefined,
    });

    fetchListInterview({
      from_date: date.format("YYYY-MM-DD"),
      to_date: date.format("YYYY-MM-DD"),
    });
  };

  useEffect(() => {
    form.resetFields();
    // Default to current date
    let current_date = moment(new Date());
    form.setFieldsValue({
      start_date: current_date,
    });
    fetchListInterview({
      from_date: current_date.format("YYYY-MM-DD"),
      to_date: current_date.format("YYYY-MM-DD"),
    });
    let data_select = dataCaditateManagement.filter((item) => selectedRowKeys.includes(item.id));

    setDataCV(data_select);
  }, [isModalAddCVInterview]);

  useEffect(() => {
    if (dataInterview != null) {
      form.setFieldsValue({
        title: dataInterview.title,
      });
    }

  }, [dataInterview]);

  return (
    <Modal
      title={"Thêm ứng viên vào lịch phỏng vấn"}
      open={isModalAddCVInterview}
      onCancel={() => {
        handleCancelCVInterview();
        form.resetFields();
      }}
      width={500}
      footer={false}
    >
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={(values) => {
          onFinishAddCVInterview(values, selectedRowKeys);
        }}
        // onFinishFailed={onFinishFailed}
        validateMessages={validateMessages}
        // loading={loading}
        initialValues={{
          remember: true,
        }}
      >
        <Row className="modal-add-candidate-row">
          <Col span={24}>
            <Form.Item
              label="Ngày phỏng vấn"
              name="start_date"
              className="modal-add-cadidate-form-item"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                suffixIcon={null}
                placeholder="DD/MM/YYYY"
                format={dateFormat}
                disabledDate={disabledDatePast}
                onChange={handleChangeDate}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Tiêu đề lịch phỏng vấn"
              name="id_interview"
              className="modal-add-cadidate-form-item"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select value={selectedTitle} onChange={setSelectedTitle}>
                {dataInterview != undefined &&
                  dataInterview.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.title}{" "}
                      {`(${moment(
                        item.start_date + "T" + item.time_start
                      ).format("HH:mm")} - ${moment(
                        item.start_date + "T" + item.time_end
                      ).format("HH:mm")})`}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={
                <>
                  Tiêu đề YCTD &nbsp;{" "}
                  <Tooltip
                    placement="bottomRight"
                    title={"Tích các checkbox bên trái cột STT trong bảng danh sách ứng viên."}
                    style={{cursor:"pointer"}}
                  >
                    <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                  </Tooltip>
                </>
              }
              name="id_cv"
              className="modal-add-cadidate-form-item"
            >
              <Select
                mode="multiple"
                defaultValue={selectedRowKeys}
                // maxTagCount={6}
                className="select-title "
              >
                {dataCV != undefined &&
                  dataCV.map((itemD) => (
                    <Select.Option
                      key={itemD.id}
                      value={itemD.id}
                      disabled
                      className="style-disabled-form-yctd"
                    >
                      {itemD.code_cv} - {itemD.title_recruitment}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={11} style={{ textAlign: "right" }}>
            <Button type="primary" htmlType="submit">
              Lưu
            </Button>
          </Col>
          <Col span={4} style={{ textAlign: "right" }}>
            <Button onClick={handleCancelCVInterview}>Thoát</Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default index;
